import { useEffect, useState } from 'react';

export default function useDebounceLastValue(value, { initialValue, delay = 200 }) {
    const [debouncedValue, setDebouncedValue] = useState(initialValue);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [value]);

    return debouncedValue;
}
